import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApplicationModule } from '@kros-sk/application-modules';
import { HttpMockService } from '@kros-sk/core/http-mock';

export const PUBLIC_DOCUMENT_MODULES_URL = '/mock/document-viewer/public-modules';

const ALL_MODULES: Record<string, ApplicationModule> = {
  public: { id: 'public', slug: 'public', name: 'Verejné', icon: 'fa-globe' },
};

const DEFAULT_MODULES = ['public'];

@Injectable()
export class PublicDocumentModulesMockService implements HttpMockService {
  get(req: HttpRequest<unknown>): ApplicationModule[] | null {
    if (req.url !== PUBLIC_DOCUMENT_MODULES_URL) {
      return null;
    }

    return DEFAULT_MODULES.map((id) => ALL_MODULES[id]);
  }
}
